export default __webpack_public_path__ + "static/media/ar-pescatori.9dd24b9c.jpg";